import { FunctionComponent, ReactNode } from "react";
import { Box, styled } from "@mui/material";

const BorderedBoxContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  border: "1px solid var(--kyocera-text-grey)",
  borderRadius: "10px",
  marginBottom: theme.spacing(4),
  display: "flex",
  alignItems: "center",
}));

interface BorderedBoxProps {
  children: ReactNode;
}

export const BorderedBox: FunctionComponent<BorderedBoxProps> = ({ children }) => {
  return (
    <BorderedBoxContainer>
      {children}
    </BorderedBoxContainer>
  );
};
